import { BlobResponse, RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from './constants';
import { ApiResponse } from 'app/types-shared';

export const api = {

  loadReportStatus: async (): Promise<any[]> => {
    const response = await new RemoteData(endpoint.loadReportStatus)
      .resource<ApiResponse<any[]>>()
      .single();
    return response.data;
  },

  downloadReportPackage: async (reportId: string): Promise<BlobResponse> => {
    return await new RemoteData(endpoint.downloadReportPackage)
      .resource<Blob>()
      .filter({ reportFileId: reportId})
      .blob();
  }
};
